import {
  Box,
  Fade,
  Image,
  ListItem,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Img } from "../../../../content/Content";
import { Link } from "react-router-dom";
import "./Banner.component.css";
const Banner = () => {
  const [langDrop, setLangDrop] = useState(false);

  const Lang = [
    {
      name: "English",
      flag: Img.us,
    },
    {
      name: "English (uk)",
      flag: Img.uk,
    },
    {
      name: "France ",
      flag: Img.france,
    },
    {
      name: "Germany",
      flag: Img.germany,
    },
  ];
  return (
    <VStack
      alignItems={"center"}
      justifyContent={"center"}
      backgroundImage={Img.BannerBg}
      bgSize={"cover"}
      bgRepeat="no-repeat"
      height={"582px"}
      className="bg_banner"
    >
      {/* desktop */}
      <Box w="80%" mx={"auto"} className="desktop-banner">
        <Box>
          <Text
            fontWeight="800"
            fontSize="77px"
            lineHeight="1.1"
            color="#fff"
            paddingBottom="0"
            marginBottom="0"
          >
            Welcome <br />
            JIFU
            <Link to={"/live"} style={{ color: "rgba(211, 7, 7, 1)" }}>
              {" "}
              LIVE
            </Link>
          </Text>
        </Box>
        <Box display="flex" alignItems="center">
          <Text color="#fff">Choose a Language</Text>
          <Stack position="relative" w="115px" mx="5px">
            <Box
              bg={"rgba(240, 240, 250, 1)"}
              marginTop={"10px"}
              display="flex"
              alignItems="center"
              cursor="pointer"
              justifyContent="space-between"
              onClick={() => setLangDrop(!langDrop)}
              borderRadius="20px"
              padding={"8px 20px"}
              width={"152px"}
            >
              <Image
                src={Img.us}
                alt="photo"
                w="28px"
                h="28px"
                borderRadius="25"
              />
              <Text
                fontSize="20px"
                fontWeight="400"
                color="#rgba(0, 0, 0, 1)"
                padding={"0"}
                margin={"0"}
              >
                English
              </Text>
            </Box>
            <Fade in={langDrop}>
              <Box
                w="146px"
                h="auto"
                top="57px"
                position="absolute"
                left={"0"}
                borderRadius="15px"
                bg="white"
                zIndex={"1111"}
              >
                <UnorderedList
                  padding="0"
                  margin="0"
                  listStyleType="none"
                  display="flex"
                  alignItems="flex-start"
                  justifyContent={"center"}
                  flexDir="column"
                >
                  {Lang.map((items) => {
                    return (
                      <ListItem padding="10px 10px" margin={"5px 0"}>
                        <Box
                          display="flex"
                          alignItems="center"
                          cursor="pointer"
                        >
                          <Image
                            src={items.flag}
                            alt="photo"
                            w="28px"
                            h="28px"
                            borderRadius="25"
                          />
                          <Text
                            fontSize="14px"
                            fontWeight="400"
                            margin="0 6px"
                            color="#000"
                          >
                            {items.name}
                          </Text>
                        </Box>
                      </ListItem>
                    );
                  })}
                </UnorderedList>
              </Box>
            </Fade>
          </Stack>
        </Box>
      </Box>
      {/* Mobile */}
      <Box w="80%" mx={"auto"} className="mobile-banner">
        <Box>
          <Text
            fontSize="36px"
            fontFamily="ProximaNova"
            fontWeight="800"
            lineHeight="1.1"
            color="#fff"
            paddingBottom="0"
            marginBottom="0"
          >
            Welcome <br />
            JIFU
            <Link to={"/live"} style={{ color: "rgba(211, 7, 7, 1)" }}>
              {" "}
              LIVE
            </Link>
          </Text>
        </Box>
        <Box
          display="flex"
          flexDir={"column"}
          alignItems="flex-start"
          py="15px"
        >
          <Text
            color="#fff"
            fontSize="14px"
            fontFamily="ProximaNova"
            fontWeight="400"
            w="100%"
            pb="5px"
            ps="10px"
          >
            Choose a Language
          </Text>
          <Stack position="relative" w="115px" mx="5px">
            <Box
              bg={"rgba(240, 240, 250, 1)"}
              marginTop={"10px"}
              display="flex"
              alignItems="center"
              cursor="pointer"
              justifyContent="flex-start"
              onClick={() => setLangDrop(!langDrop)}
              borderRadius="20px"
              padding={"8px 20px"}
              width={"152px"}
            >
              <Image
                src={Img.us}
                alt="photo"
                w="28px"
                h="28px"
                borderRadius="25"
              />
              <Text
                fontSize="14px"
                fontFamily="ProximaNova"
                fontWeight="400"
                color="#rgba(0, 0, 0, 1)"
                padding={"0"}
                margin={"0"}
                ml="20px"
              >
                English
              </Text>
            </Box>
            <Fade in={langDrop}>
              <Box
                w="146px"
                h="auto"
                top="57px"
                position="absolute"
                left={"0"}
                borderRadius="15px"
                bg="white"
                zIndex={"1111"}
              >
                <UnorderedList
                  padding="0"
                  margin="0"
                  listStyleType="none"
                  display="flex"
                  alignItems="flex-start"
                  justifyContent={"center"}
                  flexDir="column"
                >
                  {Lang.map((items) => {
                    return (
                      <ListItem padding="10px 10px" margin={"5px 0"}>
                        <Box
                          display="flex"
                          alignItems="center"
                          cursor="pointer"
                        >
                          <Image
                            src={items.flag}
                            alt="photo"
                            w="28px"
                            h="28px"
                            borderRadius="25"
                          />
                          <Text
                            fontSize="14px"
                            fontWeight="400"
                            margin="0 6px"
                            color="#000"
                          >
                            {items.name}
                          </Text>
                        </Box>
                      </ListItem>
                    );
                  })}
                </UnorderedList>
              </Box>
            </Fade>
          </Stack>
        </Box>
      </Box>
    </VStack>
  );
};

export default Banner;
